<template>
    <svg class="icon" viewBox="0 0 16 14.5455" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <!-- Mask the notch because the exported white fill remains visible when the current row has a
             tinted background.
             -->
        <mask :id="maskId" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="15">
            <rect width="16" height="15" fill="white" />
            <path d="M9.21212 4.60606V0H16V7.0303H11.6364V4.60606H9.21212Z" fill="black" />
        </mask>
        <path
            :mask="`url(#${maskId})`"
            d="M2.9697 0.969697C3.204 0.969697 3.39394 1.15964 3.39394 1.39394V1.81818H10.1818V1.39394C10.1818 1.15964 10.3718 0.969697 10.6061 0.969697C10.8404 0.969697 11.0303 1.15964 11.0303 1.39394V1.81818H11.8788C12.816 1.81818 13.5758 2.57794 13.5758 3.51515V12.8485C13.5758 13.7857 12.816 14.5455 11.8788 14.5455H1.69697C0.75976 14.5455 0 13.7857 0 12.8485V3.51515C0 2.57794 0.759759 1.81818 1.69697 1.81818H2.54545V1.39394C2.54545 1.15964 2.73539 0.969697 2.9697 0.969697ZM0.848485 4.36364V12.8485C0.848485 13.3171 1.22836 13.697 1.69697 13.697H11.8788C12.3474 13.697 12.7273 13.3171 12.7273 12.8485V4.36364H0.848485Z"
            fill="currentColor" />
        <path
            d="M12.5398 0.865657C12.566 0.732291 12.7568 0.732291 12.7829 0.865656L13.0092 2.01837C13.1061 2.51232 13.4923 2.8985 13.9862 2.99543L15.1389 3.22164C15.2723 3.24781 15.2723 3.43859 15.1389 3.46476L13.9862 3.69097C13.4923 3.78791 13.1061 4.17409 13.0092 4.66803L12.7829 5.82075C12.7568 5.95411 12.566 5.95411 12.5398 5.82075L12.3136 4.66803C12.2167 4.17409 11.8305 3.78791 11.3366 3.69097L10.1838 3.46476C10.0505 3.43859 10.0505 3.24781 10.1838 3.22164L11.3366 2.99543C11.8305 2.8985 12.2167 2.51232 12.3136 2.01837L12.5398 0.865657Z"
            fill="currentColor" />
    </svg>
</template>

<script setup lang="ts">
import { useId } from "vue";

/* Use a unique mask ID per instance to prevent document-wide SVG reference collisions. */
const maskId = useId();
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .icon {
        @apply block h-[1em] w-[1.1em] shrink-0;
    }
}
</style>
